import React from "react"
import { Card, CardBody, FormGroup, Badge } from "reactstrap"
import Field from "../../components/utils/Field"
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import { isAndroidOrIos } from "../../helpers/Utils";
import CustomPreviewWhatsApp from "../../components/utils/CustomPreviewWhatsApp";

export default (context) => {
  const M = "admFlow."
  const baseUrl = `https://${window.tenant.alias}.looc.ai/`
  const baseUrl2 = `https://wa.me/97145300045?text=${window.tenant.alias}-`
  let ctxForm = null
  let ctxSubFormDetailGrid = null
  const onCreateSuccess = (r) => {
    context.props.setLoader(false)
    if (context.state.form.flags.currentStepId === "step-1b") {
      const fetchId = r.data
      context.setState({fetchId: fetchId})
      context.getDataById(fetchId, false)
    } else if (context.state.form.flags.currentStepId === "step-5") {
      context.getDataById(context.state.fetchId, false)
    }
  }
  const onEditSuccess = (r) => {
    context.props.setLoader(false)
  }
  const changeTemplate = (ctx) => {
    context.props.setLoader(true)
    _axios
      .get(`admLocalization/get/${ctx.state.doWATemplate.value}?objectType=fetch&objectId=${context.state.idItemSelected || context.state.fetchId}`)
      .then(r => {
        context.props.setLoader(false)
        if (r.status >= 0) {
          const fields = []
          const template = r.data
          template.tagsContent.forEach((t, i) => {
            if (t.id === "fetch.title") ctx.setState({[t.id]: ctx.state.name})
            else if (t.id === "fetch.desc") ctx.setState({[t.id]: ctx.state.desc})
            else if (t.id === "header.image") ctx.setState({[t.id]: ctx.state.artUrl})
            else if (ctx.state.placeholders?.length > 0) { ctx.setState({[t.id]: ctx.state.placeholders[i]?.name ?? t.defValue }) }
            else ctx.setState({[t.id]: t.defValue ?? ""})
            if (t.id === "header.image") {
              fields.push(
                {
                  col: 12,
                  name: t.id,
                  value: "",
                  type: "dropzone",
                  label: "",
                  isDoc: false,
                  rules: 'ext:jpeg,jpg,png',
                  placeholder: "main.selectFile",
                  opts: {
                    path: ()=> "/admFetch/file",
                    accept: '.jpeg,.jpg,.png',
                    url: ctx.state.artUrl
                  }
                }
              )
            } else {
              fields.push(
                {
                  col: 6,
                  name: t.id,
                  value: "",
                  type: t.hidden || (["fetch.title", "fetch.desc"].indexOf(t.id) > -1) ? "hidden" : "text",
                  label: (L) => {
                    let label = t.id.split(".")
                    label = label.pop()
                    return L[`${M}${label}`] || L[`main.${label}`] || t.id
                  },
                  opts: {
                    style: 'float-label'
                  },
                  disabled: t.readonly
                }
              )
            }
          })
          
          ctx.setState({ selectedTemplate: r.data }, () => {
            const formFields = context.state.formFields
            let wizard = formFields.find(f => f.name === "wizard")
            wizard.steps[2].fields.find(f => f.name === "placeholders").childs = fields
            formFields[0] = wizard
            context.setState({formFields: formFields})
          })
        } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
      }).catch(e => context.props.setLoader(false))
  }
  const summary = (props) => {
    const {L, form} = props
    // const form = context.state.form

    const accessibility = () => {
      const values = {
        '0': `${L[`${M}toSpecificNumbers`]}`,
        '1': `${L[`${M}toSpecificGroups`]}`,
        '2': `${L[`${M}open`]}`
      }
      return values[form.recipientType] || ""
    }

    return (
      <section>
        {form &&
          <div>
            <Card>
              <CardBody className={"pa-1"}>
                <p><label className="w-100 mb-0">{L[`main.desc`]}</label><b>{form.name}</b></p>
                <p><label className="w-100 mb-0">{L[`${M}typeOfFetch`]}</label><b>{form.type}</b></p>                
                <p><label className="w-100 mb-1">{L[`${M}numberOfInputs`]}</label><Badge color="outline-success" pill>{form.numberOfInputs}</Badge></p>
                <p><label className="w-100 mb-1">{L[`${M}accessibility`]}</label><Badge color="outline-success" className={"mr-1"} pill>{accessibility()}</Badge></p>
                {form.recipientType !== "2" && <p><label className="w-100 mb-1">{L[`${M}countTarget`]}</label><Badge color="outline-success" pill>{form.countTarget}</Badge></p>}
                <p><label className="w-100 mb-1">{L[`${M}keywords`]}</label>{form.tags.map((item, i) => <Badge key={i} color="outline-success" className={"mr-1"} pill>{item}</Badge>)}</p>
                <p><label className="w-100 mb-0">{L[`${M}sharingUrls`]}</label></p>
                {[1].indexOf(form.sendStatus) > -1
                  ? "No"
                  : <FormGroup row>
                      <Field
                        col={12}
                        name={"url1"}
                        value={`${baseUrl}${form.url}`}
                        type={"text"}
                        locale={context.props.locale}
                        opts={{addon: {
                          append: {
                            buttons: [
                              {
                                outline: true,
                                icon: "simple-icon-docs",
                                onClick: () => {
                                  navigator.clipboard.writeText(`${baseUrl}${form.url}`)
                                  NotificationManager['success'](`${L[`${M}urlCopied`]}`, "", 5000, null, null, 'outline')
                                }
                              },
                              {
                                outline: true,
                                icon: "simple-icon-share",
                                onClick: () => {
                                  window.navigator.share({title: form.name, text: form.desc, url: `${baseUrl}${form.url}`})
                                  NotificationManager['success'](`${L[`${M}urlShared`]}`, "", 5000, null, null, 'outline')
                                },
                                renderIf: () => isAndroidOrIos()
                              }
                            ]
                          }
                        }}}
                        disabled={true}
                      />
                      <Field
                        col={12}
                        name={"url2"}
                        value={`${form.url2}`}
                        type={"text"}
                        locale={context.props.locale}
                        opts={{addon: {
                          append: {
                            buttons: [
                              {
                                outline: true,
                                icon: "simple-icon-docs",
                                onClick: () => {
                                  navigator.clipboard.writeText(`${form.url2}`)
                                  NotificationManager['success'](`${L[`${M}urlCopied`]}`, "", 5000, null, null, 'outline')
                                }
                              },
                              {
                                outline: true,
                                icon: "simple-icon-share",
                                onClick: () => {
                                  window.navigator.share({title: form.name, text: form.desc, url: `${form.url2}`})
                                  NotificationManager['success'](`${L[`${M}urlShared`]}`, "", 5000, null, null, 'outline')
                                },
                                renderIf: () => isAndroidOrIos()
                              }
                            ]
                          }
                        }}}
                        disabled={true}
                      />
                    </FormGroup>
                }
              </CardBody>
            </Card>
          </div>
        }
      </section>
    ) 
  }

  return {
    config: {
      resource: "admFetch",
      pageSize: 40,
      modal: {
        size: "lg"
      },
      list:true
    },

    actions: {
      create: context.props.userAdmin.role === '100' ? true : false,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          col: 3,
          name: "status",
          value: 0,
          type: "select",
          label: "main.status",
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "main.all"
              },
              {
                value: 0,
                label: `${M}draft`
              },
              {
                value: 1,
                label:  `${M}noSent`
              },
              {
                value: 2,
                label: `${M}sending`
              },
              {
                value: 3,
                label: `${M}sent`
              },
              {
                value: 5,
                label: `${M}paused`
              },
              {
                value: -1,
                label: `${M}seeErrors`
              }
            ]
          }
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          renderIf: (ctx) => true,
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          const { recipientType, triggerType, groupId, groupName, doWATemplate, doWATemplateName, tags } = r.data
          const tagsArray = tags ? tags.split(",") : []
          const name = tagsArray[0] ?? ""
          
          r.data = {
            ...r.data,
            recipientType: recipientType.toString(),
            selectedRecipientType: recipientType.toString(),
            triggerType: triggerType.toString(),
            scheduled: r.data.activeFrom != null,
            selectedTriggerType: triggerType.toString(),
            groupId: groupId ? { value: groupId, label: groupName } : "",
            doWATemplate: doWATemplate ? { value: doWATemplate, label: doWATemplateName } : doWATemplate,
            tags: tagsArray,
            url: name,
            url2: name ? `${baseUrl2}${name}` : ""
          }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (!context.state.idItemSelected) v.templateId = v.select1 ?? v.select2 ?? v.select3 ?? v.select4 ?? 0
        v.tags = v.tags.toString()
        v.recipientType = +v.recipientType || 0
        v.maxCollections = +v.maxCollections || 0
        v.groupId = v.groupId?.value ?? v.groupId
        v.triggerType = v.triggerType === "true"
        v.doWATemplate = v.doWATemplate?.value
        if (!v.scheduled) {
            v.activeFrom = null
            v.activeTo = null
        }
        v.step= (() => {
          const wizard = context.view?.form?.fields.find(f => f.type === "wizard")
          if (wizard) return wizard.steps.find(s => s.id === v.flags.currentStepId).name
        })()
        const tagsContent = v.selectedTemplate?.tagsContent
        let placeholders = []
        if (v.selectedTemplate?.tagsContent) {
          tagsContent.forEach(t => {
            placeholders.push({ID: t.id, name: v[t.id] || ""})
          })
          v.placeholders = placeholders
        }

        delete v.select1
        delete v.select2
        delete v.select3
        delete v.select4
        delete v.flags
        delete v.selectedField
        delete v.selectedTemplate
        delete v.inputs
        return v
      },
      onCreateSuccess: onCreateSuccess,
      onEditSuccess: onEditSuccess,
      afterCloseModal: () => {
        context.setState({fetchId: null})
      },
      fields: [
        {
          col: 12,
          name: "wizard",
          value: "step-1",
          type: "wizard",
          saveByStep: true,
          onChange: (stepId) => {
            context.setState({
              hideBtnSave: stepId === "step-5",
              btnCancel: stepId === "step-5" ? "main.close" : "main.cancel"
            })
          },
          steps: [
            {
              id: "step-1",
              name: `${M}whatToCollect`,
              desc: `${M}whatToCollectDesc`,
              fields: [
                {
                  col: 12,
                  name: "label1",
                  value: L => `<h3 class="mb-0">${L[`${M}whatToCollect`]}</h3><span class='text-muted text-small'>${L[`${M}whatToCollectDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "selectedType",
                  value: "",
                  type: "text",
                  label: "",
                  rules: "required",
                  rulesMessages: {messages: {required: 'Select a type'}},
                  opts: {
                    inputWrapperClassName: "d-none"
                  }
                },
                {
                  name: "templateId",
                  type: "hidden"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}data`,
                  opts: {
                    value: "data",
                    desc: `${M}descData`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "select1",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "data"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}document`,
                  opts: {
                    value: "document",
                    desc: `${M}descDocument`,
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}signatureOrPDF`,
                  opts: {
                    value: "signature",
                    desc: `${M}descSignatureOrPDF`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "select3",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "signature"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}locationInfo`,
                  opts: {
                    value: "location",
                    desc: `${M}descLocationInfo`,
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}identityVerification`,
                  opts: {
                    value: "kyc",
                    desc: `${M}descIdentityVerification`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}book`,
                  opts: {
                    value: "book",
                    desc: `${M}descBook`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectBook",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "book"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}checkout`,
                  opts: {
                    value: "checkout",
                    desc: `${M}descCheckout`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectCheckout",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "checkout"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}form`,
                  opts: {
                    value: "form",
                    desc: `${M}descForm`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectForm",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "form"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}order`,
                  opts: {
                    value: "order",
                    desc: `${M}descOrder`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectOrder",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "order"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}regist`,
                  opts: {
                    value: "regist",
                    desc: `${M}descRegist`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectRegist",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "regist"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}remote`,
                  opts: {
                    value: "remote",
                    desc: `${M}descRemote`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectRemote",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "remote"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}transfer_wa`,
                  opts: {
                    value: "transfer_wa",
                    desc: `${M}descTransfer_wa`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "selectTransferWa",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "transfer_wa"
                },
                {
                  col: 12,
                  name: "type",
                  value: "",
                  type: "radio",
                  label: `${M}moreFetches`,
                  opts: {
                    value: "other",
                    desc: `${M}descMoreFetches`
                  },
                  onChange: ctx => ctx.setState({selectedType: ctx.state.type})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "select4",
                  value: "",
                  type: "select",
                  label: "main.category",
                  parent: "type",
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    searchOnline: true,
                    path: () => `admFetch/get?pick=true&filterBy=template&type=${context.state?.form?.type}`
                  },
                  disabled: () => context.state.form?.type !== "other"
                },
              ],
              renderIf: () => !context.state.idItemSelected
            },
            {
              id: "step-1b",
              name: `${M}properties`,
              desc: `${M}propertiesDesc`,
              method: () => `/admFetch/edit/${context.state.fetchId}`,
              fields: [
                {
                  col: 6,
                  name: "name",
                  value: "",
                  type: "text",
                  label: `${M}fetchName`,
                  placeholder: `${M}exampleFetchName`,
                  rules: "required|max:50",
                  opts: {
                    style: 'float-label',
                  },
                  onChange: (ctx) => {
                    const title = "fetch.title"
                    ctx.setState({[title]: ctx.state.name})
                  }
                },
                {
                  col: 12,
                  name: "desc",
                  value: "",
                  type: "textarea",
                  rules: "max:1000",
                  label: `Conversational prompt`,
                  placeholder:`Write the tone, personality, style of the agent behind this flow`,
                  opts: {
                    rows: "10"
                  },
                  renderIf: () => context.props.userAdmin.role >= 95
                },
                {
                  col: 12,
                  name: "tab-prompt",
                  value: false,
                  type: "collapsible",
                  label: `${M}promptWarning` ,
                  childs: [
                    {
                      col: 12,
                      name: "prompt",
                      value: "",
                      type: "textarea",
                      rules: "max:5000",
                      placeholder:`[System prompt]`,
                      opts: {
                        rows: "40"
                      }
                    }
                  ],
                  renderIf: () => context.props.userAdmin.role === '100'
                },
                {
                  col: 12,
                  name: "btnOpenInputs",
                  type: "button",
                  label: `${M}contextRAG`,
                  opts: {
                    wrapperClassName: "d-flex justify-content-end"
                  },
                  onClick: (ctx) => {
                    ctx.toogleSubForm(1)  // Using index 1 since it's the second subform
                  }
                }
              ]
            },
            {
              id: "step-2",
              name: `${M}properties`,
              desc: `${M}propertiesDesc`,
              method: () => `/admFetch/edit/${context.state.fetchId}`,
              fields: [
                {
                  name: "artUrl",
                  type: "hidden"
                },
                {
                  col: 12,
                  name: "label2",
                  value: L => `<h3 class="mb-0">${L[`${M}properties`]}</h3><span class='text-muted text-small'>${L[`${M}propertiesDesc`]}</span>`,
                  type: "label"
                }
              ]
            },
            {
              id: "step-3",
              name: `${M}accessibility`,
              desc: `${M}accessibilityDesc`,
              method: () => `/admFetch/edit/${context.state.fetchId}`,
              fields: [
                {
                  col: 12,
                  name: "label3",
                  value: L => `<h3 class="mb-0">${L[`${M}accessibility`]}</h3><span class='text-muted text-small'>${L[`${M}accessibilityDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "selectedRecipientType",
                  value: "",
                  type: "text",
                  label: "",
                  rules: "required",
                  rulesMessages: {messages: {required: 'Select a type'}},
                  opts: {
                    inputWrapperClassName: "d-none"
                  }
                },
                {
                  col: 12,
                  name: "recipientType",
                  type: "radio",
                  label: `${M}toSpecificNumbers`,
                  opts: {
                    value: "0",
                    desc: `${M}descToSpecificNumbers`,
                  },
                  onClick: (ctx) => {
                    ctx.toogleSubForm(0)
                    ctxForm = ctx
                  },
                  onChange: ctx => ctx.setState({selectedRecipientType: ctx.state.recipientType})
                },
                {
                  col: 12,
                  name: "btnOpenSpecificNumbers",
                  type: "button",
                  label: "main.edit",
                  opts: {
                    wrapperClassName: "d-flex justify-content-end"
                  },
                  onClick: (ctx) => {
                    ctx.toogleSubForm(0)
                    ctxForm = ctx
                  },
                  renderIf: ctx => ctx.state.groupIdOfFetch > 0 && ctx.state.recipientType === "0"
                },
                {
                  col: 12,
                  name: "recipientType",
                  type: "radio",
                  label: `${M}toSpecificGroups`,
                  opts: {
                    value: "1",
                    desc: `${M}descToSpecificGroups`
                  },
                  onChange: ctx => ctx.setState({selectedRecipientType: ctx.state.recipientType})
                },
                {
                  name: "groupIdOfFetch",
                  type: "hidden"
                },
                {
                  col: 6,
                  offset: 6,
                  name: "groupId",
                  value: null,
                  type: "select",
                  label: "main.category",
                  rules: "required",
                  // parent: "recipientType",
                  opts: {
                    style: 'float-label',
                    path: "admGroup/get?staff=0",
                  },
                  renderIf: () => context.state.form?.recipientType === "1"
                },
                {
                  col: 12,
                  name: "recipientType",
                  type: "radio",
                  label: `${M}open`,
                  opts: {
                    value: "2",
                    desc: `${M}descOpen`,
                  },
                  onChange: ctx => ctx.setState({selectedRecipientType: ctx.state.recipientType})
                },
                {
                  col: 6,
                  offset: 6,
                  name: "maxCollections",
                  value: 100,
                  type: "number",
                  label: `${M}maximumRequest`,
                  rules: "required|numeric|min:1,num",
                  opts: {
                    style: 'float-label',
                  },
                  renderIf: () => context.state.form?.recipientType === "2"
                },
                {
                  col: 12,
                  name: "tags",
                  value: [],
                  type: "tag",
                  label: `${M}keywordsOrPhrases`,
                  rules: "required|max:3,array",
                  placeholder: `${M}pressEnterToAdd`,
                  opts: {
                    validationRegex: /^[A-Za-z0-9-]+$/,
                    addKeys: [9, 13, 188]
                  },
                  onChange: (ctx) => {
                    const name = ctx.state.tags?.length > 0 ? ctx.state.tags[0] : ""
                    ctx.setState({url: name, url2: `${baseUrl2}${name}`})
                  }
                },
                {
                  col: 12,
                  name: "url",
                  value: "",
                  type: "text",
                  label: `${M}sharingURL`,
                  rules: "required",
                  opts: {
                    addon: {
                      prepend: {
                        texts: [`${baseUrl}`]
                      }
                    }
                  },
                  onChange: (ctx) => {
                    ctx.setState({url2: `${baseUrl2}${ctx.state.url}`})
                  }
                },
                {
                  col: 12,
                  name: "url2",
                  value: "",
                  type: "text",
                  label: `${M}orAlternative`,
                  opts: {
                    style: 'float-label',
                  },
                  disabled: true
                },
                {
                  col: 12,
                  name: "msgNotAvailable",
                  value: "",
                  type: "text",
                  label: `${M}msgNotAvailable`,
                  rules: "required",
                  opts: {
                    style: 'float-label',
                  },
                  renderIf: (ctx) => !ctx.state.langSwitch
                },
                {
                  col: 12,
                  name: "isPublic",
                  value: false,
                  type: "switch",
                  label: `${M}descOpen`,
                  renderIf: () => context.state.form?.recipientType !== "2"
                },
                {
                  col: 12,
                  name: "allowMultiple",
                  value: false,
                  type: "switch",
                  label: `${M}allowMultiple`
                },
                // Moved from step 4 - Availability section
                {
                  col: 12,
                  name: "label4",
                  value: L => `<h3 class="mb-0">${L[`${M}availability`]}</h3><span class='text-muted text-small'>${L[`${M}availabilityDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 6,
                  name: "isLive",
                  value: true,
                  type: "switch",
                  label: `${M}isLive`,
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "scheduled",
                  value: false,
                  type: "switch",
                  label: `${M}scheduled`,
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: (ctx) => ctx.state.isLive
                },
                {
                  col: 12,
                  name: "empty1",
                  type: "separator",
                },
                {
                  type: "daterange",
                  isFormCrud: true,
                  range: {
                    col: 4,
                    rules: () => !context.state.form.activeFrom && !context.state.form.activeTo ? "required" : null,
                    renderIf: (ctx) => ctx.state.isLive && ctx.state.scheduled
                  },
                  from: {
                    col: 4,
                    name: "activeFrom",
                    value: "",
                    type: "date",
                    label: "main.from",
                    rules: "required",
                    renderIf: (ctx) => ctx.state.isLive && ctx.state.scheduled
                  },
                  to: {
                    col: 4,
                    name: "activeTo",
                    value: "",
                    type: "date",
                    label: "main.to",
                    rules: "required",
                    renderIf: (ctx) => ctx.state.isLive && ctx.state.scheduled
                  }                  
                },
              ]
            },
            {
              id: "step-4",
              name: `${M}followups`,
              desc: `${M}followupsDesc`,
              method: () => `/admFetch/edit/${context.state.fetchId}`,
              fields: [
                {
                  col: 12,
                  name: "label7",
                  value: L => `<h3 class="mb-0">${L[`${M}followups`]}</h3><span class='text-muted text-small'>${L[`${M}followupsDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "enableFollowups",
                  value: false,
                  type: "switch",
                  label: `${M}enableConversationMovers`,
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "defaultDelay",
                  value: 2,
                  type: "number",
                  label: `${M}defaultDelay`,
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 6,
                  name: "defaultDelayUnit",
                  value: "hours",
                  type: "select",
                  label: `${M}defaultDelayUnit`,
                  opts: {
                    style: 'float-label',
                    items: [
                      { value: "minutes", label: "Minutes" },
                      { value: "hours", label: "Hours" },
                      { value: "days", label: "Days" }
                    ]
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 6,
                  name: "maxTotalFollowups",
                  value: 5,
                  type: "number",
                  label: `${M}maxTotalFollowups`,
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 6,
                  name: "followupBudget",
                  value: 100,
                  type: "number",
                  label: `${M}followupBudget`,
                  opts: {
                    style: 'float-label',
                    addon: {
                      prepend: {
                        texts: ["$"]
                      }
                    }
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 12,
                  name: "stopOnEngagement",
                  value: false,
                  type: "switch",
                  label: `${M}stopOnEngagement`,
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 12,
                  name: "requireOptIn",
                  value: false,
                  type: "switch",
                  label: `${M}requireOptIn`,
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                },
                {
                  col: 12,
                  name: "followupRules",
                  value: "",
                  type: "textarea",
                  label: `${M}followupRules`,
                  placeholder: "Enter additional predefined followup instructions. Remeber the main behavior of this followup always going to be ruled by the flow definitionitself.",
                  opts: {
                    rows: "3"
                  },
                  renderIf: (ctx) => ctx.state.enableFollowups
                }
              ]
            },
            {
              id: "step-5",
              name: `${M}summary`,
              desc: `${M}summaryDesc`,
              method: () => `/admFetch/edit/${context.state.fetchId}`,
              fields: [
                {
                  col: 12,
                  name: "label6",
                  value: L => `<h3 class="mb-0">${L[`${M}summary`]}</h3><span class='text-muted text-small'>${L[`${M}summaryDesc`]}</span>`,
                  type: "label"
                },
                {
                  name: "sendStatus",
                  type: "hidden"
                },
                {
                  name: "countTarget",
                  type: "hidden"
                },
                {
                  name: "countSent",
                  type: "hidden"
                },
                {
                  name: "countSeen",
                  type: "hidden"
                },
                {
                  name: "countComplete",
                  type: "hidden"
                },
                {
                  name: "countPartial",
                  type: "hidden"
                },
                {
                  name: "numberOfInputs",
                  type: "hidden"
                },
                {
                  col: 12,
                  name: "summary",
                  value: "",
                  type: "component",
                  opts: {
                    component: summary
                  }
                }
              ]
            }
          ]
        }
      ],
      subforms: [
        {
          size: "md",
          name: `${M}mobileNumbers`,
          wrapClassName: "mb-4",
          fields: [
            {
              col: 12,
              name: "tabs",
              value: "copyPaste",
              type: "tabs",
              tabs: [
                {
                  id: "copyPaste",
                  name:  `${M}copyPaste`,
                  fields: [
                    {
                      col: 12,
                      name: "phoneList",
                      value: "",
                      type: "textarea",
                      label: `${M}enterMobileNumbers`,
                      placeholder: "Sample:\n+51963214569\n+51969875563\n+51963369852",
                      rules: "required",
                      opts: {
                        rows: "12"
                      }
                    }
                  ]
                },
                {
                  id: "fromCSV",
                  name: `${M}fromCSV`,
                  fields: [
                    {
                      col: 12,
                      name: "btnTemplate",
                      type: "button",
                      label: "main.downloadExcelTemplate",
                      onClick: () => {
                        window.open(`/tplmails/dwn/UsersImport.xlsx`, "_blank")
                      }
                    },
                    {
                      col: 12,
                      name: "data",
                      value: "",
                      type: "dropzone",
                      rules: "required",
                      placeholder: "main.selectFile",
                      opts: {
                        accept: '.csv',
                        output: true
                      }
                    }
                  ]
                }
              ]
            },
            {
              col: 12,
              name: "useGroupLabel",
              value: (L) => `<h5>${L[`${M}useGroup`]}</h5>`,
              type: "label",
            },
            {
              col: 12,
              name: "useGroup",
              value: false,
              type: "switch",
              label: `${M}loadContacts`,
              onChange: ctx => {
                if (!ctx.state.useGroup) ctx.setState({
                  groupId: null,
                  groupName: null
                }, () => {
                  ctxSubFormDetailGrid.setState({data: []})
                })
              }
            },
            {
              col: 6,
              name: "groupId",
              value: null,
              type: "select",
              label: "main.category",
              rules: "required",
              opts: {
                style: 'float-label',
                path: "admGroup/get?staff=0",
                setOutput: v => { if (v) return {value: v.value, label: v.label} },
              },
              onChange: ctx => {
                if (ctx.state.groupId) ctxSubFormDetailGrid.setState({resource: `admUser/group/${ctx.state.groupId.value}`}, () => {
                  ctxSubFormDetailGrid.getData()
                })
                else ctxSubFormDetailGrid.setState({data: []})
              },
              renderIf: ctx => ctx.state.useGroup,
              disabled: ctx => ctx.state.groupName
            },
            {
              col: 6,
              name: "groupName",
              value: "",
              type: "text",
              label: `${M}newGroup`,
              opts: {
                style: "float-label"
              },
              renderIf: ctx => ctx.state.useGroup,
            }
          ],
          buttons: [
            {
              label: `${M}addNumbers`,
              isMain: true,
              onClick: (ctx) => {
                ctx.validateForm().then(() => {
                  context.props.setLoader(true)
                  const fetchId = context.state.idItemSelected || context.state.fetchId
                  const groupIdOfFetch = context.state.form.groupIdOfFetch
                  const body = {
                    data: ctx.state.data?.[0]?.value || null,
                    phoneList: ctx.state.phoneList || null,
                    groupId: ctx.state.groupName ? 0 : (ctx.state.groupId ? ctx.state.groupId.value : groupIdOfFetch),
                    groupName: ctx.state.groupName || (!groupIdOfFetch ? `fetch_${fetchId}` : null)
                  }

                  _axios
                    .post(`admUser/importAttach`, body)
                    .then(r => {
                      if (r.status === 0) {
                        ctxForm.toogleSubForm(0)
                        if (ctx.state.useGroup) {
                          ctxForm.setState({
                            recipientType: "1", 
                            groupId: ctx.state.groupName
                            ? {value: r.data?.groupId, label: ctx.state.groupName}
                            : {value: ctx.state.groupId.value, label: ctx.state.groupId.label}
                          })
                        } else if (!ctx.state.useGroup && r.data?.groupId) {
                          ctxForm.setState({
                            recipientType: "0",
                            // groupId: {value: r.data.groupId, label: r.data.groupId},
                            groupIdOfFetch: r.data.groupId
                          })
                        }
                      }
                      NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                      context.props.setLoader(false)
                    }).catch(e => context.props.setLoader(false))
                })
                .catch(e => { /* console.log(e) */ })
              }
            }
          ],
          detailGrid: () => {
            return {
              module: 'admUser',
              embeded: (ctx) => {
                ctxSubFormDetailGrid = ctx
                return {
                  config: {
                    pageSize: 40,
                    resource: `admUser/group/${context.state.form?.groupIdOfFetch || 0}`,
                  },
              
                  actions: {
                    delete: true
                  },

                  columns: [
                    {
                      Header: "main.ID",
                      accessor: "ID"
                    },
                    {
                      Header: "main.name",
                      accessor: "name"
                    },
                    {
                      Header: "main.lastName",
                      accessor: "last"  
                    }
                  ]
                }
              }
            }
          }
        },
        {
          size: "md",
          name: `${M}contextRAG`,
          wrapClassName: "mb-4",
          fields: [{
            col: 12,
            name: "label6",
            value: L => `<span class='text-muted text-small'>${L[`${M}contextRAGDesc`]}</span>`,
            type: "label"
          }],
          detailGrid: (ctx) => {
            return {
              module: 'admFlowInput',
              config: {
                hiddenTitle: true
              },
              filterBy: () => { return { fetchId: context.state.idItemSelected || context.state.fetchId, type:'context' } },
              renderIf: () => (context.state.idItemSelected || context.state.fetchId) && context.props.userAdmin.role === '100',
              listenData: (data) => {
                if (context.state.form && data) {
                  const form = context.state.form
                  form.inputs = data.map(item => item = {name: item.name, options: item.options})
                  context.setState({form: form}, () => {
                    if (ctx.state.selectedTemplate) changeTemplate(ctx)
                  })
                }
              }
            }
          }
        }
      ],
      detailGrid: (ctx) => {
        return {
          module: 'admFlowInput',
          config: {
            hiddenTitle: true
          },
          filterBy: () => { return { fetchId: context.state.idItemSelected || context.state.fetchId } },
          renderIf: () => (context.state.idItemSelected || context.state.fetchId) && context.state.form?.flags?.currentStepId === "step-2",
          listenData: (data) => {
            if (context.state.form && data) {
              const form = context.state.form
              form.inputs = data.map(item => item = {name: item.name, options: item.options})
              context.setState({form: form}, () => {
                if (ctx.state.selectedTemplate) changeTemplate(ctx)
              })
            }
          }
        }
      }
    },

    columns: [
      {
        Header: "main.name",
        accessor: "name",
        minWidth: 180
      },
      {
        Header: "main.ID",
        accessor: "ID",
      },
      {
        Header: "main.mode",
        accessor: "mode",
      },
      {
        Header: "main.type",
        accessor: "type",
      },
      {
        Header: "main.status",
        accessor: "sendStatus",
        type: 'chip',
        chips: {
          0: {text: 'Draft', color:'lightgreen'},
          1: {text: 'Ready', color:'lightgreen'},
          2: {text: 'Sending', color:'lightgreen'},
          3: {text: 'Sent', color:'green'},
          4: {text: 'Cancelled', color:'red'},
          5: {text: 'Sending errors', color:'red'}
        }
      }
    ],

    preview: {
      template: CustomPreviewWhatsApp,
      previewOf: {
        form: {
          name: `main.whatsappMessagePreview`,
          handleData: (data) => {
            if (!data) return
            let msgs = []
            let header = data?.selectedTemplate?.content
            let buttons = []
            const tagsContent = data?.selectedTemplate?.tagsContent
            if (tagsContent) {
              /*
              tagsContent.forEach(t => {
                if (data[t.id]) {
                  content = content.replaceAll(`{{${t.id}}}`, data[t.id])
                }
              })
              */
              tagsContent.forEach((t, index) => {
                if (data[t.id]) {
                  header = header.replaceAll(`{{${index+1}}}`, data[t.id])
                }
                if (t.id.includes("button")) {
                  buttons.push(data[t.id])
                }
              })
            }
            const m = {
              type: "received",
              content: header,
              buttons: buttons
            }
            msgs.push(m)
            if (data.inputs) {
              msgs = msgs.concat(data.inputs.map(item => item = {type: "received", content: item.name, buttons: item.options ? item.options.split("|") : []}))
            }
            return msgs
          }
        }
      },
      renderIf: () => context.state.form?.selectedTemplate && context.state.form?.flags?.currentStepId === "step-2"
    }
  }
}